export const MasterDataCacheURL = Object.freeze({
    GetAllRejectedReasonList: '/RejectedReason/GetAllRejectedReasonList', 
    GetAllChannels:'/ChannelManagement/GetAllChannels', 
    GetAllJobOpening: '/JobOpening/GetAllJobOpening',
    GetPublishedJobOpening: '/JobOpening/GetAllJobOpening?publishedOnly=true',
    GetDraftAndPublishedJobOpening: '/JobOpening/GetAllJobOpening?excludeInactive=true',
    GetAllSourceManagement: '/SourceManagement/GetAllSourceManagement',
    GetAllApplicantStatus: '/ApplicantStatus/GetAllApplicantStatus',
    GetAllDepartments: '/Department/GetAllDepartments',
    GetAllStatus: '/Comman/GetAllStatus',
    GetAllFollowUpReasonList: '/FollowUpReason/GetAllFollowUpReasonList',
    GetAllInterviewRoundList: '/InterviewRound/GetAllInterviewRoundList',
    GetEmploymentType: '/employmentType/GetEmploymentType',
    GetAllSkillCategories: '/SkillCategorie/GetAllSkillCategories',
    GetAllRoles: '/RoleManagement/GetAllRoles',
    GetAllInterviewTypeList: '/InterviewType/GetAllInterviewTypeList',
    GetAllSkills: '/skillManagement/GetAllSkill',
    GetTestPurposes: '/TestTemplate/GetTestPurposes',
    GetTestModes: '/TestTemplate/GetTestModes',
    GetAllApplicant:'/ManageApplicants/GetAllApplicant'
});

export const DependentDataCacheURL = Object.freeze({
    GetAllSourceByChannelId: '/SourceManagement/GetAllSourceByChannelId',
    GetAllUsersByRoleId: '/UserManagement/GetAllUsersByRoleId',
    GetAllSkillByCategoriesId: '/SkillManagement/GetAllSkillByCategoriesId',
    GetAvailableSlots: '/InterviewerCalendar/GetAvailableSlots'
})